import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-ink-200/70 bg-white p-10 text-center shadow-xs">
      <div className="pointer-events-none absolute -top-12 left-1/2 h-44 w-44 -translate-x-1/2 rounded-full bg-brand-gradient-soft blur-2xl" />
      {icon ? (
        <div className="relative mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-gradient text-white shadow-md">
          {icon}
        </div>
      ) : null}
      <h3 className="relative text-lg font-semibold text-ink-900">{title}</h3>
      {description ? (
        <p className="relative mx-auto mt-1.5 max-w-md text-sm text-ink-600">
          {description}
        </p>
      ) : null}
      {action ? (
        <div className="relative mt-6 flex justify-center">{action}</div>
      ) : null}
    </div>
  );
}
